import axios from "../../../utilities/axios";

export const paymentFailRequest = async (): Promise<void> => {
  try {
    const response = await axios.post<void>(
      `${process.env.REACT_APP_BASE_URL}/users/payment/fail`,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}
